var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[{ 'adjust-position': _vm.bar.width < 58 }, _vm.bar.labelClassColor, _vm.bar.labelClassText],style:({ width: ((_vm.bar.width) + "px") })},[_vm._v(" "+_vm._s(_vm.bar.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }